import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B02UserManagementPage } from '../b02-user-management/b02-user-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B09SettingPage } from '../b09-setting/b09-setting';

/**
 * Generated class for the B02bUserInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b09d-setting-info',
  templateUrl: 'b09d-setting-info.html',
})
export class B09dSettingInfoPage {
  private todo : FormGroup;
  loading: any;
  Status: any;
  // [CXY:23/05/2020:CR/MB/20-01]:Added TIN_NO to settingData
  settingData = {COMPANY:'', TIN_NO:'',
                ADD1:'', ADD2:'', ADD3:'',
                CONTACT_NO1: '',CONTACT_NO2: '', EMAIL:'', FAQ:'',
                TERMS:'',  HOWTOUSE:'', INV_OVERUSE:''     
              }
  BRANCH_ID:any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

    this.todo = this.formBuilder.group({
      company: ['', Validators.required],
      tinNo: ['', Validators.required], // [CXY:23/05/2020:CR/MB/20-01]:Added
      address: ['', Validators.required],
  //      town: ['', Validators.required],
      postCode: ['', Validators.required],
      state: ['', Validators.required],
    //      country: ['', Validators.required],
      phone: ['', Validators.required],
      contact_no2: [], 
      email: ['', Validators.required],
      overdue: [], 
      faq: [], 
      terms: [], 
      howtouse: [], 
      inv: [], 
    });

    this.BRANCH_ID = this.navParams.get('paramID');    //corporate ID

    let tbl = ["SETTING"];
    let column = ["ID"];
    let value = ["1"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"SETTING","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        this.loading.dismiss();

        let Records = result["Records"];
        this.settingData.COMPANY = Records[0]["COMPANY"];
        this.settingData.TIN_NO = Records[0]["TIN_NO"]; // [CXY:23/05/2020:CR/MB/20-01]:Added
        this.settingData.ADD1 = Records[0]["ADD1"];
        this.settingData.ADD2 = Records[0]["ADD2"];
        this.settingData.ADD3 = Records[0]["ADD3"];
        this.settingData.CONTACT_NO1 = Records[0]["CONTACT_NO1"];
        this.settingData.CONTACT_NO2 = Records[0]["CONTACT_NO2"];
        this.settingData.EMAIL = Records[0]["EMAIL"];
        this.settingData.FAQ = Records[0]["FAQ"];
        this.settingData.TERMS = Records[0]["TERMS"];
        this.settingData.HOWTOUSE = Records[0]["HOWTOUSE"];
        this.settingData.INV_OVERUSE = Records[0]["INV_OVERUSE"];
        console.log(this.settingData);

      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02bCompanyInfoPage');
  }

  

  updateUser(){
    this.serviceapi.updatedata('SETTING', 'ID', '1', this.settingData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B09SettingPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  goToUser(){
    this.navCtrl.setRoot(B09SettingPage);
  }
  
  goTo(){
    this.navCtrl.setRoot(B09SettingPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b09d-setting-info/b09d-setting-info.ts